
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "Home", href: "/" },
    { name: "Mission", href: "/mission" },
    { name: "Work", href: "/work" },
    { name: "Board", href: "/board" },
    { name: "SpudBot Assistant", href: "/chatbot" },
    { name: "Contact Us", href: "/contact" },
  ];

  return (
    <nav className="fixed w-full bg-white/90 backdrop-blur-sm z-50 shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link to="/">
              <div className="h-16 w-16 rounded-full bg-white flex items-center justify-center overflow-hidden">
                <img
                  src="/lovable-uploads/47f7a40a-1652-4194-97ca-60d534629618.png"
                  alt="SPO Logo"
                  className="h-full w-full object-contain"
                />
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-gray-600 hover:text-primary transition-colors"
              >
                {item.name}
              </Link>
            ))}
          </div>

          <Link to="/membership">
            <Button 
              variant="default"
              className="hidden md:flex bg-[#1e3a8a] hover:bg-[#1e3a8a]/90 text-white font-semibold px-6"
            >
              Join Us
            </Button>
          </Link>

          {/* Mobile Navigation */}
          <div className="md:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent>
                <div className="flex flex-col space-y-4 mt-8">
                  {navItems.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="text-lg text-gray-600 hover:text-primary transition-colors"
                      onClick={() => setIsOpen(false)}
                    >
                      {item.name}
                    </Link>
                  ))}
                  <Link to="/membership" onClick={() => setIsOpen(false)}>
                    <Button 
                      variant="default"
                      className="w-full bg-[#1e3a8a] hover:bg-[#1e3a8a]/90 text-white font-semibold"
                    >
                      Join Us
                    </Button>
                  </Link>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
